import React, { FC } from 'react';

import { Grid } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { IProps } from '../../FlightItem';
import Slot from '../Slot/Slot';
import { mapInitialToGender } from '../../Utils/mapGenderLabels';
import { PanelHeaderContentStyled } from './Components/PanelHeaderContent.Styles';
import { AccordionSummaryStyled } from './Components/AccordionSummary.Styles';
import { parseHandicap } from '../../Utils/parseHandicap';
import { parseAge } from '../../Utils/parseAge';

interface IFlightItemSummaryProps extends IProps {
  toggleExpanded: () => void;
}

const FlightItemSummary: FC<IFlightItemSummaryProps> = props => {
  const { item, type, enrollments, toggleExpanded } = props;

  return (
    <AccordionSummaryStyled
      expandIcon={
        !!enrollments.length ? (
          <ExpandMoreIcon fontSize="large" color="primary" />
        ) : (
          <div style={{ minWidth: '35px' }} />
        )
      }
      onClick={toggleExpanded}
      aria-controls="panel1a-content"
    >
      <PanelHeaderContentStyled>
        <Grid className="bottom" container={true} spacing={2} alignItems="center">
          <Grid item={true} xs={4} className="slot-container">
            <Slot label="" value={item.name} />
          </Grid>

          <Grid item={true} xs={2} className="slot-container">
            <Slot label="" value={`${enrollments.length} ${type}s`} />
          </Grid>

          <Grid item={true} xs={2} className="slot-container">
            <Slot label="" value={item.gender ? mapInitialToGender[item.gender] : 'Both'} />
          </Grid>

          <Grid item={true} xs={2} className="slot-container">
            <Slot label="HANDICAP RANGE" value={parseHandicap(item)} />
          </Grid>

          <Grid item={true} xs={2} className="slot-container">
            <Slot label="AGE RANGE" value={parseAge(item)} />
          </Grid>
        </Grid>
      </PanelHeaderContentStyled>
    </AccordionSummaryStyled>
  );
};

export default FlightItemSummary;
